//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './bulk-actions-overlay.html';

import angular from 'angular';

import '../bulk-selection-overlay-container/bulk-selection-overlay-container';

angular.module('curalate').component('universalImageActionsOverlay', {
  bindings: {
    alwaysShowSelection: '<',
    context: '<',
    disableBulkActions: '<',
    showInfoIcon: '<?',
    itemId: '@',
    itemIdCallback: '&',
    itemType: '@',
    onAddToGalleryCallback: '&',
    onImageClickedCallback: '&',
    page: '@',
    shouldShowGalleryText: '<',
    shouldShowConnectText: '<',
    hideItemDetails: '<',
    getTrueItemIdOnInit: '<',
    isSmallImage: '<',
  },
  template,
});
